import React, { useEffect, useState } from 'react';
import { adminApi } from '../../lib/api';

export default function AdminQuotes() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.quotes().then(setItems).catch(() => setItems([])).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="mb-5">
        <h2 className="text-xl font-bold text-[#0b1f3a]">Quotes</h2>
        <p className="text-slate-500 text-sm mt-1">All quotes saved by users.</p>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        {loading ? (
          <p className="p-8 text-center text-slate-500 text-sm">Loading...</p>
        ) : items.length === 0 ? (
          <p className="p-8 text-center text-slate-500 text-sm">No quotes yet.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 text-xs uppercase tracking-wider">
              <tr>
                <th className="text-left px-4 py-3 font-semibold">Property</th>
                <th className="text-left px-4 py-3 font-semibold">Province</th>
                <th className="text-left px-4 py-3 font-semibold">Insurers</th>
                <th className="text-left px-4 py-3 font-semibold">Best price</th>
                <th className="text-left px-4 py-3 font-semibold">Status</th>
                <th className="text-left px-4 py-3 font-semibold">Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((q) => (
                <tr key={q.id} className="hover:bg-slate-50/50">
                  <td className="px-4 py-3 text-slate-700">{q.data?.address || '—'}</td>
                  <td className="px-4 py-3 text-slate-600">{q.data?.province || '—'}</td>
                  <td className="px-4 py-3 text-slate-600">{(q.quotes || []).length}</td>
                  <td className="px-4 py-3 text-slate-700 font-semibold">{q.quotes?.[0] ? `€${q.quotes[0].premium}` : '—'}</td>
                  <td className="px-4 py-3"><span className="text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5 rounded-full bg-slate-100 text-slate-600">{q.status}</span></td>
                  <td className="px-4 py-3 text-slate-600">{new Date(q.created_at).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
